var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{attrs:{"id":"videoElement","controls":"","autoplay":"","muted":"","width":"100%"},domProps:{"muted":true}}),_c('button',{on:{"click":_vm.play}},[_vm._v("播放")])])}
var staticRenderFns = []

export { render, staticRenderFns }